function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#54C1FC;}\r\n\t.st1{fill:#FFFFFF;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Visuals_00000163773919475137426220000013452011937392109246_"
}, /*#__PURE__*/React.createElement("g", {
  id: "Landing_00000173147885361945723950000005550475496444522681_",
  transform: "translate(-150.000000, -50.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Topmenu_00000154396425253688321510000000524382246436597655_",
  transform: "translate(150.000000, 45.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-Copy_00000103981844755590055000000013744060786918893719_",
  transform: "translate(0.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2_00000000189214571907479670000010733740282473434004_",
  transform: "translate(19.000000, 17.500000) rotate(90.000000) translate(-19.000000, -17.500000) translate(5.000000, -1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_00000159461708719975118150000017752786326064268216_",
  className: "st0",
  d: "M4.66-42.15h52.81 c1.22,0,2.03,0.81,2.03,2.03V-32c0,1.22-0.81,2.03-2.03,2.03H17.45c-1.22,0-2.03,0.81-2.03,2.03v40.62 c0,1.22-0.81,2.03-2.03,2.03H4.66c-1.22,0-2.03-0.81-2.03-2.03v-52.81C2.63-41.34,3.44-42.15,4.66-42.15z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-Copy_00000047030870025968718550000013471507205463590280_",
  className: "st0",
  d: "M57.47,33H4.66 c-1.22,0-2.03-0.81-2.03-2.03v-8.12c0-1.22,0.81-2.03,2.03-2.03h40.01c1.22,0,2.03-0.81,2.03-2.03v-40.62 c0-1.22,0.81-2.03,2.03-2.03h8.73c1.22,0,2.03,0.81,2.03,2.03v52.81C59.5,32.19,58.69,33,57.47,33z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M118.45,24.2c-1.62-2.03-4.27-3.25-6.7-3.25s-5.28,0.81-5.28,3.66c0,2.44,2.23,3.25,5.69,4.47 c5.08,1.62,11.58,3.86,11.58,11.17c0,8.53-6.91,12.39-14.22,12.39c-5.28,0-10.77-2.03-14.02-5.48l5.89-6.09 c1.83,2.23,5.08,4.06,8.12,4.06c2.84,0,5.08-1.02,5.08-4.06c0-2.84-2.84-3.66-7.72-5.28c-4.67-1.62-9.55-4.06-9.55-10.77 c0-8.33,7.52-11.78,14.42-11.78c4.27,0,8.94,1.62,12.19,4.67L118.45,24.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M155.42,41.06h-19.09c0.2,2.84,3.25,4.87,6.3,4.87c2.84,0,4.67-1.22,5.89-2.84l6.09,3.86 c-2.44,3.66-6.7,5.69-11.98,5.69c-7.92,0-14.42-5.08-14.42-13.81c0-8.53,6.3-14.02,14.22-14.02c7.72,0,13.2,5.28,13.2,14.22 C155.62,39.64,155.62,40.45,155.42,41.06z M147.49,35.58c0-2.84-1.83-5.08-5.08-5.08s-5.69,2.23-5.89,5.08H147.49z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M189.13,51.83h-10.77l-8.53-12.59h-0.2v12.59h-8.73V11.81h8.73v24.37h0.2l8.33-10.77h10.56L178.57,37.2 L189.13,51.83z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M209.04,51.83v-3.66h-0.2c-1.22,2.23-4.27,4.47-7.92,4.47c-7.11,0-9.55-5.48-9.55-10.77V25.63h8.73v14.22 c0,3.05,0.81,5.69,3.86,5.69s4.67-2.64,4.67-5.69V25.63h8.73v26.2H209.04z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M241.13,32.53c-0.81-0.2-1.62-0.2-2.23-0.2c-4.67,0-6.09,3.86-6.09,5.89v13.61h-8.73v-26.2h8.33v3.86h0.2 c1.22-2.64,3.86-4.47,7.11-4.47c0.61,0,1.42,0,1.83,0.2L241.13,32.53z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M249.46,21.97c-2.84,0-4.87-2.23-4.87-4.67s2.23-4.67,4.87-4.67c2.84,0,4.87,2.03,4.87,4.67 C254.54,19.74,252.3,21.97,249.46,21.97z M245.19,51.83v-26.2h8.73v26.2H245.19z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M270.18,31.92v9.95c0,2.44,0.81,3.66,3.25,3.66c0.81,0,1.83-0.2,2.44-0.41l0.2,6.3 c-1.22,0.41-3.25,0.81-5.08,0.81c-7.11,0-9.34-3.66-9.34-9.34V31.72h-4.27v-6.5h4.27v-6.7h8.53v6.91h6.09v6.5H270.18z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M279.93,29.08c3.05-2.84,7.52-4.47,11.78-4.47c8.73,0,12.19,4.27,12.19,13.81v13.41h-7.92v-2.84h-0.2 c-1.22,2.23-4.27,3.45-7.52,3.45c-4.27,0-9.55-2.03-9.55-8.33c0-7.52,9.14-8.94,16.86-8.94v-0.41c0-2.64-2.03-3.86-4.67-3.86 c-2.44,0-4.87,1.22-6.5,2.64L279.93,29.08z M295.97,40.45h-1.02c-3.86,0-8.12,0.41-8.12,3.66c0,2.03,2.03,2.64,3.66,2.64 c3.45,0,5.48-2.03,5.48-5.48V40.45z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M327.46,51.83V37.41c0-2.84-0.81-5.48-3.86-5.48s-4.67,2.64-4.67,5.69v14.22h-8.73v-26.2h8.33v3.66h0.2 c1.22-2.23,4.27-4.47,7.92-4.47c7.11,0,9.55,5.48,9.55,10.77v16.25H327.46z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M360.97,33.95c-1.02-1.22-2.84-2.03-4.67-2.03c-3.66,0-6.09,3.05-6.09,6.7c0,3.66,2.44,6.7,6.09,6.7 c1.83,0,3.66-0.61,4.67-2.03l4.87,5.89c-2.23,2.03-5.89,3.45-9.75,3.45c-8.33,0-14.83-5.28-14.83-14.02 c0-8.53,6.5-14.02,14.62-14.02c3.66,0,7.72,1.42,9.75,3.45L360.97,33.95z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M395.3,41.06H376.2c0.2,2.84,3.25,4.87,6.3,4.87c2.84,0,4.67-1.22,5.89-2.84l6.09,3.86 c-2.44,3.66-6.5,5.69-11.98,5.69c-7.92,0-14.42-5.08-14.42-13.81c0-8.53,6.3-14.02,14.22-14.02c7.72,0,13.2,5.28,13.2,14.22 C395.5,39.64,395.5,40.45,395.3,41.06z M387.38,35.58c0-2.84-1.83-5.08-5.08-5.08s-5.69,2.23-5.89,5.08H387.38z"
})))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M288.22,7.26c0,2.5-1.87,4.05-4.87,4.05h-2.26v3.09h-2.59V3.19h4.85C286.34,3.19,288.22,4.75,288.22,7.26z  M285.59,7.26c0-1.23-0.8-1.95-2.39-1.95h-2.11V9.2h2.11C284.79,9.2,285.59,8.48,285.59,7.26z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M289.52,8.8c0-3.33,2.59-5.8,6.13-5.8c3.52,0,6.13,2.45,6.13,5.8c0,3.35-2.61,5.8-6.13,5.8 C292.11,14.59,289.52,12.13,289.52,8.8z M299.15,8.8c0-2.13-1.5-3.59-3.51-3.59c-2,0-3.51,1.46-3.51,3.59 c0,2.13,1.5,3.59,3.51,3.59C297.65,12.38,299.15,10.93,299.15,8.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M320.3,3.19l-3.67,11.21h-2.79l-2.47-7.59l-2.55,7.59h-2.77l-3.68-11.21h2.69l2.53,7.88l2.64-7.88h2.4 l2.56,7.94l2.61-7.94H320.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M330.42,12.32v2.08h-8.68V3.19h8.47v2.08h-5.89v2.43h5.2v2.02h-5.2v2.59H330.42z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M339.63,14.4l-2.16-3.12h-0.13h-2.26v3.12h-2.59V3.19h4.85c2.99,0,4.87,1.55,4.87,4.07 c0,1.68-0.85,2.91-2.31,3.54l2.51,3.6H339.63z M337.2,5.31h-2.11v3.91h2.11c1.59,0,2.39-0.74,2.39-1.95 C339.58,6.03,338.78,5.31,337.2,5.31z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M352.93,12.32v2.08h-8.68V3.19h8.47v2.08h-5.89v2.43h5.2v2.02h-5.2v2.59H352.93z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M355,3.19h5.09c3.67,0,6.18,2.21,6.18,5.6c0,3.39-2.51,5.6-6.18,5.6H355V3.19z M359.96,12.27 c2.23,0,3.68-1.33,3.68-3.47c0-2.15-1.46-3.47-3.68-3.47h-2.37v6.95H359.96z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M383.04,11.34c0,1.94-1.54,3.06-4.48,3.06h-5.8V3.19h5.48c2.8,0,4.24,1.17,4.24,2.91 c0,1.12-0.58,1.98-1.49,2.47C382.24,8.97,383.04,9.93,383.04,11.34z M375.33,5.15v2.64h2.58c1.26,0,1.95-0.45,1.95-1.33 s-0.69-1.31-1.95-1.31H375.33z M380.43,11.07c0-0.94-0.72-1.39-2.07-1.39h-3.03v2.77h3.03C379.7,12.45,380.43,12.03,380.43,11.07z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M390.15,10.43v3.97h-2.59v-4l-4.34-7.2h2.75l2.99,4.98l2.99-4.98h2.55L390.15,10.43z"
})));

function SvgPoweredBySekuritance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 66",
    style: {
      enableBackground: "new 0 0 400 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredBySekuritance);
export default __webpack_public_path__ + "static/media/powered-by-sekuritance.82fbb240.svg";
export { ForwardRef as ReactComponent };